module.exports = __webpack_public_path__ + "static/media/checkedCheckBox.317ae773.svg";